import { CForm } from '@coreui/react';
import { useFormik } from 'formik'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import authService from '../../../../service/reactQueryServices/services/authService';
import { customTrim, isValidEmailStrictly } from '../../../../components/helper';


const SendEmail = ({ setState }: { setState: Function }) => {
  const { mutateAsync: sendResetPasswordEmail, isLoading } = useMutation("sendResetPasswordEmail", authService.sendResetPasswordEmailService);

  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const validation = Yup.object({
    email: Yup.string().required(t("ERRORS.EMILE_REQ") || "").test("isValid", t("ERRORS.EMILE_INVALID") || "", function (value: any) {


      if (!isValidEmailStrictly(customTrim(value))) {
        return false
      }

      return true
    }),

  })


  const handleSubmit = async (values: any) => {

    try {
      const response = await sendResetPasswordEmail(formik.values.email)

    } catch (error) {
      console.log(error)
    }
  }
  const formik = useFormik({
    validationSchema: validation,
    initialValues: { email: '' },
    onSubmit: handleSubmit,
  })


  return (
    <div>

      <h4 className='icon-title d-flex flex-row justify-content-cener'><b>{t('TITLES.RESET_PASSWORD')}</b></h4>
      <p>{t("DESCRIPTIONS.RESET_PASSWORD")}</p>
      <CForm onSubmit={formik.handleSubmit} >

        <div className="form-group">
          <label htmlFor="inputEmail1" className='d-flex flex-row justify-content-start lbl-frm' >{t('COLUMNS.EMAIL')}
            <span className='color-red' >*</span></label>

          <input type='email' name="email" id="inputEmail1"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className='form-control input-email' placeholder={t('COLUMNS.EMAIL') || ""} />
          {formik.errors.email && formik.touched.email && <label className='label-danger '>{formik.errors.email}</label>}
        </div>
        <div className='d-flex flex-row justify-content-end'>
          <button className="btn btn-default mx-2"
            type="submit" onClick={() => navigate("/login")} > {t('BACK')}</button>
          <button className="btn btn-primary"
            disabled={!formik.isValid || !formik.dirty}
            type="submit" >  {false ?
              <div className="spinner-border" role="status" aria-hidden="true"></div> : t('ACTION.NEXT')}</button>

        </div>
      </CForm>
    </div>

  )
}

export default SendEmail